import { render, staticRenderFns } from "./ManagementAdvanced.vue?vue&type=template&id=2763339c&scoped=true"
import script from "./ManagementAdvanced.vue?vue&type=script&lang=ts"
export * from "./ManagementAdvanced.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2763339c",
  null
  
)

export default component.exports